<nz-select
  class="ui-select"
  nzDropdownClassName="ui-select-dropdown"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  [nzDisabled]="disabled"
  [nzSize]="size"
  [nzAllowClear]="false"
  [nzShowSearch]="false"
  [nzPlaceHolder]="placeholder"
>
  @for (option of options; track (optionValueField ? option[optionValueField] :
  option)) {
  <nz-option
    [nzLabel]="option | getFieldValue : optionLabelField | localization"
    [nzValue]="option | getFieldValue : optionValueField"
  ></nz-option>
  }
</nz-select>
